import {
    Show,
    useRecordContext,
    TextField,
    ReferenceField,
    Pagination,
    Datagrid,
    ReferenceManyField,
    RichTextField,
    SimpleShowLayout,
} from 'react-admin';

import { Chapters } from '../../custom';
import ThumbnailField from '../../common/ThumbnailField';
import { useState } from 'react';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import AssignEcomProductModal from '../../common/ecom-products/AssignEcomProductModal';
import AssignedUserList from '../../common/ecom-products/AssignedUserList';
import { useAssignRefresh } from '../../hooks/useAssignRefresh';
import AssignedEcomProductList from '../../common/ecom-products/AssignedEcomProductList';

const ChapterShow = () => {
    const [activeTab, setActiveTab] = useState(0);
    const { refreshKey, handleAssignSuccess } = useAssignRefresh();
    const handleTabClick = (index: any) => {
        setActiveTab(index);
    };
    let { chapterId } = useParams();
    if (!chapterId) {
        return <LoadingSection />;
    }

    const tabData = [
        {
            label: 'Details',
            content: (
                <div>
                    <Show title={<Title />} resource={'chapters'} id={chapterId}>
                        <SimpleShowLayout>
                            <ThumbnailField size={'large'} source="image" />
                            <TextField source="name" />
                            <RichTextField source="description" />
                            <TextField source="displayOrder" />
                            <TextField source="exercisesCount" />
                            <TextField source="homeworksCount" />
                            <TextField source="lecturesCount" />
                            <TextField source="notesCount" />
                            <TextField source="programStatus" />
                            <TextField source="slug" />
                            <TextField source="status" />
                            <TextField source="totalExercises" />
                            <TextField source="totalLectureDurationsInSeconds" />
                            <TextField source="totalNotes" />
                            <TextField source="totalVideos" />
                            <TextField source="videosCount" />
                        </SimpleShowLayout>
                    </Show>
                </div>
            ),
        },

        {
            label: 'Product Details',
            content: (
                <Show id={chapterId} resource={'chapters'}>
                    <SimpleShowLayout>
                        <AssignedEcomProductList type="chapter" typeId={chapterId} refreshKey={refreshKey} />
                    </SimpleShowLayout>
                </Show>
            ),
        },
        {
            label: 'Students',
            content: (
                <div>
                    <AssignedUserList type="chapters" typeId={chapterId} refreshKey={refreshKey} />
                </div>
            ),
        },
    ];

    return (
        <>
            <div className="flex justify-end mr-10 pt-5 pb-2">
                <AssignEcomProductModal
                    type="chapter"
                    typeId={chapterId}
                    title="Assign Chapter"
                    onSuccess={handleAssignSuccess}
                />
            </div>
            <div className="  border rounded-md">
                <div className=" border-collapse flex text-lg felx-row gap-16 px-10 pt-4 ">
                    {tabData.map((tab, index) => (
                        <div
                            key={index}
                            onClick={() => handleTabClick(index)}
                            className={`tab ${
                                index === activeTab
                                    ? 'active text-[#4f3cc9]  underline decoration-4 underline-offset-[20px]'
                                    : ''
                            }`}
                        >
                            {tab.label}
                        </div>
                    ))}
                </div>
                <div className="tab-content">{tabData[activeTab].content}</div>
            </div>
        </>
    );
};

const Title = () => {
    const record = useRecordContext<Chapters>();
    return record ? <span>{record.name}</span> : null;
};

export default ChapterShow;
